import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  CssBaseline,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CallAlertBar from "../../../Layout/Alertbar";
import AddUpdateOT from "./AddUpdateOT";
import { useNavigate } from "react-router-dom";
import OTActionMenu from "./OTActionMenu";

const OTIndex = () => {
  const navigate = useNavigate();

  const [otList, setOtList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [otFormData, setOtFormData] = useState({});
  const [selectedOT, setSelectedOT] = useState(null);

  // Alerts
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const loadOTList = () => {
    callApi(
      API_ENDPOINTS.MASTER_GET_OVERTIME_MASTER_RULES_LIST,
      "POST",
      { "Content-Type": "application/json" },
      { p_company_id: 13, p_plant_id: 1 }
    )
      .then((data) => {
        if (data && data.length > 0) setOtList(data);
        else {
          setAlertSeverity("warning");
          setAlertTitle("Warning");
          setAlertMessage("No OT data found!");
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity("error");
        setAlertTitle("Error");
        setAlertMessage("Unable to load OT details");
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    loadOTList();
  }, []);

  const handleAddOT = () => {
    setOtFormData({});
    setSelectedOT(null);
    setIsFormOpen(true);
  };

  const handleEditOT = (ot) => {
    setOtFormData(ot);
    setSelectedOT(ot);
    setIsFormOpen(true);
  };


const handleRowClick = (ot) => {
  setSelectedOT(ot);       // Pass this OT to AddUpdateOT
  setIsFormOpen(true);     // Open the form
};
  const handleExit = () => {
    setIsFormOpen(false);
    loadOTList();
  };

  const handleBack = () => navigate("/");

  return (
    <Grid>
      <CssBaseline />

      {/* Action Menu Always on Top */}
      <OTActionMenu
        title="Overtime Master"
        showNew={!isFormOpen}
        onNew={handleAddOT}
        onExit={handleBack}
        isEdit={!!selectedOT}
      />

      {!isFormOpen && (
        <>
          {/* <AppBar position="static" sx={{ backgroundColor: "inherit" }}>
            <Toolbar>
              <Typography variant="h5">OverTime Master</Typography>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<AccessTimeIcon />}
                sx={{ ml: "auto", textTransform: "none" }}
                onClick={handleAddOT}
              >
                New OT
              </Button>
              <IconButton onClick={handleBack}>
                <Close style={{ fontSize: "16px", color: "#2196F3" }} />
              </IconButton>
            </Toolbar>
          </AppBar> */}

          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          <Grid container padding={1} spacing={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  maxHeight: "75vh",
                  overflowY: "auto",
                  border: "1px solid #1976d2",
                  borderRadius: 1,
                }}
              >
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>OT CODE</TableCell>
                        <TableCell>OT NAME</TableCell>
                        <TableCell>STATE</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {otList.map((ot) => (
                        <TableRow
                          key={ot.ot_id}
                          hover
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleEditOT(ot)}
                        >
                          <TableCell
                            style={{
                              color: "teal",
                              textDecoration: "underline",
                            }}
                          >
                            {ot.ot_code}
                          </TableCell>
                          <TableCell>{ot.ot_name}</TableCell>
                          <TableCell>{ot.state_name}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {isFormOpen && (
  <AddUpdateOT
    selectedOT={selectedOT}          // Pass the selected OT
    onClose={() => setIsFormOpen(false)}
    refreshOTList={loadOTList}
  />
)}
    </Grid>
  );
};

export default OTIndex;
